// @ts-nocheck
import { Column } from 'react-table'
import { NameCell } from './NameCell'
import { ActiveCell } from './ActiveCell'
import { ExpirationCell } from './ExpirationCell'
import { LinkedEntityCell } from './LinkedEntityCell'
import { PaymentOptionCell } from './PaymentOptionCell'
import { UpdatedInCell } from './UpdatedInCell'
import { CreatedInCell } from './CreatedInCell'
import { SelectionCell } from './SelectionCell'
import { CustomHeader } from './CustomHeader'
import { SelectionHeader } from './SelectionHeader'
import { CieloMerchant } from '../../../core/_models'

const CieloMerchantColumns: ReadonlyArray<Column<CieloMerchant>> = [
  {
    Header: (props) => <SelectionHeader tableProps={props} />,
    id: 'selection',
    Cell: ({ ...props }) => <SelectionCell id={props.data[props.row.index].id} />,
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='Vínculo' className='min-w-125px' />,
    id: 'linkedEntity',
    Cell: ({ ...props }) => <LinkedEntityCell cieloMerchant={props.data[props.row.index]} />,
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='Nome' className='min-w-125px' />,
    id: 'name',
    Cell: ({ ...props }) => <NameCell cieloMerchant={props.data[props.row.index]} />,
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='EC' className='min-w-100px' />,
    accessor: 'ec',
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='Merchant ID' className='min-w-125px' />,
    accessor: 'merchantId',
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='Opção de pagamento' className='min-w-150px' />,
    id: 'paymentOption',
    Cell: ({ ...props }) => <PaymentOptionCell cieloMerchant={props.data[props.row.index]} />,
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='Ativo' className='min-w-75px' />,
    id: 'active',
    Cell: ({ ...props }) => <ActiveCell cieloMerchant={props.data[props.row.index]} />,
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='Expiração' className='min-w-125px' />,
    id: 'expirationAt',
    Cell: ({ ...props }) => <ExpirationCell cieloMerchant={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Criado em' className='min-w-125px' />
    ),
    id: 'data',
    Cell: ({ ...props }) => <CreatedInCell cieloMerchant={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <CustomHeader tableProps={props} title='Atualizado em' className='min-w-125px' />
    ),
    id: 'two_steps',
    Cell: ({ ...props }) => <UpdatedInCell cieloMerchant={props.data[props.row.index]} />,
  },

]

export { CieloMerchantColumns }
